module.exports = __webpack_public_path__ + "img/ios3.365aa385.png";